export interface KeyState {
    digits: Set<string>;
    enter: boolean;
    backspace: boolean;
}
/** Prefix filtering prevents constructing an answer that was never offered. */
export function enabledKeys(typed: string, choices: string[] | null): KeyState {
    if (choices === null)
        return { digits: new Set(typed.length >= 5 || typed === "0" ? [] : "0123456789"), enter: /^(0|[1-9][0-9]{0,4})$/.test(typed), backspace: true };
    const live = choices.filter(c => c.startsWith(typed));
    return { digits: new Set(live.map(c => c[typed.length]).filter(Boolean)), enter: live.includes(typed), backspace: true };
}
export function pressKey(typed: string, key: string, choices: string[] | null): string {
    if (key === "backspace")
        return typed.slice(0, -1);
    return enabledKeys(typed, choices).digits.has(key) ? typed + key : typed;
}
